import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { RemedialModel } from "../../models/remedial.model";

@Component({
  selector: 'app-modal-custom-remedial',
  templateUrl: './modal-custom-remedial.component.html',
  styleUrls: ['./modal-custom-remedial.component.scss'],
})
export class ModalCustomRemedialComponent implements OnInit {

  constructor(public appearanceService: AppearanceService, public modalController: ModalController) { }

  customRemedial = new RemedialModel();
  otherCode: string = "";
  otherName: string = "";

  nameError: boolean = false;
  chargeError: boolean = false;
  stlError: boolean = false;


  pound: number = 0;
  pence: string = "0";

  ngOnInit() {}


  ionViewWillEnter()
  {
    this.pound = 0;
    this.pence = "00";

    this.nameError = false;
    this.chargeError = false;
    this.stlError = false;

    this.customRemedial = new RemedialModel();
    this.customRemedial.stlCode = "REA502";
    this.customRemedial.name = "";
    this.customRemedial.charge = "0.00";
  }


  doesRemedialHaveErrors(): boolean
  {
    var errorFound = false;
    this.nameError = false;
    this.chargeError = false;
    this.stlError = false;

    if (this.customRemedial.name == "")
    {
      this.nameError = true;
      errorFound = true;
    }

    if (this.customRemedial.stlCode == "")
    {
      this.stlError = true;
      errorFound = true;
    }

    if (this.pence.length < 2)
    {
      this.chargeError = true;
      errorFound = true;
    }

    this.customRemedial.charge = this.pound + "." + this.pence;

    var check = Number(this.customRemedial.charge);

    if (isNaN(check))
    {
      this.chargeError = true;
      errorFound = true;
    }

    return errorFound;
  }


  addCustomRemedial()
  {
    if (this.customRemedial.name == "other")
    {
      this.customRemedial.name = this.otherName;
    }

    if (this.customRemedial.stlCode == "other")
    {
      this.customRemedial.stlCode = this.otherCode;
    }

    if (this.doesRemedialHaveErrors())
    {
      return;
    }

    var returnData = { customRemedial: this.customRemedial };
    this.modalController.dismiss(returnData, null, 'CustomRemedialModal');
  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'CustomRemedialModal');
  }
}
